import { render, staticRenderFns } from "./Profile-page.vue?vue&type=template&id=32ae6ff3&scoped=true&"
import script from "./Profile-page.vue?vue&type=script&lang=js&"
export * from "./Profile-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ae6ff3",
  null
  
)

export default component.exports